/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import {range, sum} from 'ramda';
/**
 * The internal dependencies.
 */
import {TASKS_QUANTITY_BATCH_SIZE} from '../../../../common/constants';
import {convertToItems} from '../../../../common/utilities';
import InputScrollSelect from '../../../../components/general/input-scroll-select';
import Button from '../../../../components/task/shop/form/button';

const InputWrappers = styled.div`
	display: flex;
	align-items: center;

	> div + div {
		margin-left: 10px;
	}
`;

const ActionsWrapper = styled.div`
	flex: 1;
`;

const ResultsText = styled.p`
	text-align: center;
	color: #3b3b3b;
	font-size: 40px;
	font-weight: 600;
`;

const SmallText = styled.span`
	font-size: 14px;
	padding-left: 15px;
`;

class QuantityInput extends React.Component {
    constructor(props) {
        super(props);

        this.types = ['high', 'low'];

        const value = this.props.data.maxValue;
        const remainder = value % TASKS_QUANTITY_BATCH_SIZE;

        this.state = {
            high: value - remainder,
            low: value > TASKS_QUANTITY_BATCH_SIZE ? TASKS_QUANTITY_BATCH_SIZE : 0,
        };
    }

    handleQuantityChange(type, value) {

        // TODO Fix calculation
        const oppositeType = this.types.filter(t => t !== type)[0];

        const args = {
            [type]: value
        };

        if (this.quantityOveflows(value, oppositeType)) {
            args[oppositeType] = this.getPossiblePreviousValue(oppositeType);
        }

        this.setState(args, this.updateData)
    };

    getPossiblePreviousValue(type) {
        const value = this.state[type];
        let previousValue = 0;

        if (value % TASKS_QUANTITY_BATCH_SIZE === 0) {
            previousValue = value - TASKS_QUANTITY_BATCH_SIZE;
        }

        return previousValue >= 0
            ? previousValue
            : 0;
    }

    updateData() {
        const {high, low} = this.state;
        this.props.handleSelect(sum([high, low]));
    }

    getHighQuantityValues() {
        const {data} = this.props;
        const {high} = this.state;
        let factors = [];

        if (data.maxValue < TASKS_QUANTITY_BATCH_SIZE) {
            factors = [0];
        } else {
            let max = Math.floor(data.maxValue / TASKS_QUANTITY_BATCH_SIZE);
            factors = [...range(0, max), max];
        }

        return convertToItems(
            factors.map(i => i * TASKS_QUANTITY_BATCH_SIZE),
            high
        );
    }

    getLowQuantityValues() {
        const {data} = this.props;
        const {low} = this.state;
        let items = [];

        let max = data.maxValue % TASKS_QUANTITY_BATCH_SIZE;

        if (max === 0 && data.maxValue < TASKS_QUANTITY_BATCH_SIZE) {
            items = [0];
        } else if (data.maxValue < TASKS_QUANTITY_BATCH_SIZE){
            items =[...range(0, data.maxValue + 1)];
        }
        else {
            items = [...range(0, TASKS_QUANTITY_BATCH_SIZE - 1)];
            // max = max ? max : TASKS_QUANTITY_BATCH_SIZE - 1;
            // items = [...range(0, max), max];
        }

        return convertToItems(
            items,
            low
        );
    }

    quantityOveflows = (val, opositeType) => sum([val, this.state[opositeType]]) > this.props.data.maxValue;

    render() {
        const {data, handleComplete} = this.props;

        const items = [
            {type: 'high', values: this.getHighQuantityValues()},
            {type: 'low', values: this.getLowQuantityValues()}
        ];

        // console.log("ITMES:", items);

        return (
            <InputWrappers>
                {items.map((select, index) => (
                    <InputScrollSelect
                        key={`quantity-select-input-${index}`}
                        items={select.values}
                        handleChange={(value) => this.handleQuantityChange(select.type, value)}
                    />
                ))}

                <ActionsWrapper>
                    <ResultsText>
                        {data.value}

                        <SmallText>
                            Stk.
                        </SmallText>
                    </ResultsText>

                    <Button handleClick={() => handleComplete(data)}/>
                </ActionsWrapper>
            </InputWrappers>
        );
    }
}

export default QuantityInput;



// WEBPACK FOOTER //
// ./src/components/task/shop/form/quantity-input.js